<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-toolbar dense flat class="red white--text">
      Diese Seite ist bisher statisch und befindet sich noch im Aufbau!
      <!-- <v-tooltip bottom>
        <template v-slot:activator='{ on }'>
          <v-btn icon v-on='on'><v-icon>add</v-icon></v-btn>
        </template>
        <span>Neue Rechnung</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-text-field
          v-model='search'
          append-icon='search'
          label='Suchen'
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="12" md="4" lg="3" v-for="eintrag in eintrage" :key="eintrag.id">
        <v-card>
          <v-card-title>
            {{ eintrag.titel }}
            <v-spacer></v-spacer>
            <v-icon small>open_in_new</v-icon>
          </v-card-title>
          <v-card-text>
            {{ eintrag.beschreibung }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-action>
            <v-chip small class="pa-2 ma-1" v-for="tag in eintrag.tags" :key="tag">
              {{ tag }}
            </v-chip>
          </v-card-action>
        </v-card>
      </v-col>
    </v-row>
    



  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        eintrage: [
          {
            id: 1,
            titel: 'Maiparty',
            beschreibung: 'Informationen zum Aufbau und Ablauf der Maiparty',
            tags: ['Veranstaltung', 'Party', 'Aufbau', 'Sommersemester'],
            kommentare: [],
            zuletzt_bearbeitet: '2020-10-03'
          },
          {
            id: 2,
            titel: 'Fahnenhissung',
            beschreibung: 'Aufbau, Essen Ablauf der Fahnenhissung',
            tags: ['Veranstaltung', 'Aufbau', 'Wintersemester'],
            kommentare: [],
            zuletzt_bearbeitet: '2020-06-28'
          },
          {
            id: 3,
            titel: 'Semesterprogramm',
            beschreibung: 'Versandinformationen Semesterprogramm',
            tags: ['Versand', 'Porto'],
            kommentare: [],
            zuletzt_bearbeitet: '2020-09-11'
          }
        ]
      }
    },
    computed: {
      test () {
        return 'kategorien'
      }
    },
    methods: {
      test () {
        return 'text'
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// lexikon.vue?641bb08c